export default __webpack_public_path__ + "static/Header-e1b5c269ced9638536dcc66daf6817e5.png";